import { RouteRecordRaw } from 'vue-router';
import * as CONST from '@/const'

let routes: RouteRecordRaw[] = [
    {
        path: '/appConfiguration',
        name: 'appConfiguration',
        component: () => import("./views/appConfiguration.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.SuperAdmin]
        }
    },
];

export default routes;
